import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL_NEW } from '/src/lib/endpoints';
import { formatCount } from '/src/lib/helpers';

const REGION_TABS = [
    { id: 'mena',          label: 'MENA' },
    { id: 'africa',        label: 'Africa' },
    { id: 'southeastAsia', label: 'Southeast Asia' },
];

const METRICS = [
    { key: 'startups',      label: 'Startups' },
    { key: 'ecosystems',    label: 'Investment Firms' },
    { key: 'fundingRounds', label: 'Funding Rounds' },
    { key: 'exits',         label: 'Exits' },
    { key: 'founders',      label: 'Founders' },
    { key: 'investors',     label: 'Investors' },
];

function normalizeRegionData(data) {
    return {
        startups: data.startups        || 0,
        ecosystems: data.investment_firms || 0,
        fundingRounds: data.funding_rounds  || 0,
        exits: data.exits           || 0,
        founders: data.founders        || 0,
        investors: data.investors       || 0,
    };
}

export default function Stats() {
    const [activeTab, setActiveTab] = useState('mena');
    const [allCounts, setAllCounts] = useState(null);
    const [loading, setLoading]     = useState(true);

    const tab = REGION_TABS.find(t => t.id === activeTab);

    useEffect(() => {
        axios.get(`${API_URL_NEW}/ecosystem/explore-metrics`)
            .then(r => {
                if (r.data.status === 200) {
                    const { mena, africa, southeastAsia } = r.data.data;
                    setAllCounts({
                        mena: normalizeRegionData(mena),
                        africa: normalizeRegionData(africa),
                        southeastAsia: normalizeRegionData(southeastAsia),
                    });
                }
            })
            .catch(() => {})
            .finally(() => setLoading(false));
    }, []);

    const counts = allCounts ? allCounts[activeTab] : {};

    return (
        <section className="lp-data">
            <div className="row lp-data__inner">
                <div className="col-md-5 lp-data__text">
                    <div className="lp-data__tabs">
                        {REGION_TABS.map(t => (
                            <button
                                key={t.id}
                                className={`lp-data__tab${activeTab === t.id ? ' lp-data__tab--active' : ''}`}
                                onClick={() => setActiveTab(t.id)}
                            >
                                {t.label}
                            </button>
                        ))}
                    </div>
                    <h2>Explore Our {tab.label} Data</h2>
                    <p>
                        Discover the most comprehensive, accurate, and timely intelligence
                        for the complex private capital markets.
                    </p>
                    <a className="btn btn-main" href="/startups">Explore Our Data</a>
                </div>

                <div className="col-md-7">
                    <div className="row lp-data__counts" key={activeTab}>
                        {METRICS.map(({ key, label }) => (
                            <div className="col-4 lp-data__count" key={key}>
                                <div className="sort-box">
                                    <div className="sort-count">
                                        {loading ? '—' : formatCount(counts[key] || 0)}
                                    </div>
                                    <div>{label}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
